import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateMrfType from "./CreateMrfType";
import { getMrfTypeDropdownData, createMrfType } from "services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
  dropdownData: state.MaterialRequistionForm.dropdownData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMrfTypeDropdownData,
      createMrfType,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateMrfType);
